import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/reducers/root";
import { changeModalState } from "../../redux/actions/modal/modal";
import { getPropertySelectionList, removeProperty, resetRemoveProperty } from "../../redux/actions/propertySelectionList/propertySelectionList";
import AmpButton from "../common/AmpButton/AmpButton";

import "./RemoveProperty.css"
import { setToastNotification } from "../../redux/actions/toastNotification/toastNotification";

interface RemovePropertyProps {
    roll: string;
    ownerType: string,
    afterRemove?: (roll: string, own: string) => void
}

export default function RemoveProperty(props: RemovePropertyProps){

    const {roll, ownerType} = props;

    const { t } = useTranslation('propertySelectionList');

    const removePropertyState: Record<string, unknown> = useSelector((state: RootState) => state.propertyListReducer.removeProperty);

    const dispatch = useDispatch();

    useEffect(() => {
        if (!removePropertyState.loading && removePropertyState.status) {
            if (removePropertyState.status === 200 && removePropertyState.success) {
                dispatch(setToastNotification(roll + t("remove-property-modal.toast-success") as string, "success"));
                dispatch(changeModalState("modal-fade-out"));
                const userProfileId = window.localStorage.getItem("userProfileId");
                userProfileId && dispatch(getPropertySelectionList(userProfileId));
                dispatch(resetRemoveProperty());

                if(props.afterRemove) {
                    props.afterRemove(roll, ownerType);
                }

            } else if (removePropertyState.status === 500 || removePropertyState.success === false) {
                let message = t("remove-property-modal.toast-fail") as string;
                if (removePropertyState.message) {
                    if (removePropertyState.message as string === "Last Prop Cannot Be Removed"){
                        message = t("remove-property-modal.toast-fail-last") as string;
                    } else {
                        message = removePropertyState.message as string;
                    }
                }
                dispatch(setToastNotification(message, "error"));
                dispatch(changeModalState("modal-fade-out"));
                dispatch(resetRemoveProperty());
            }
        }
    }, [removePropertyState, dispatch, t, roll, props, ownerType]);

    const confirmRemoveProperty = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        const userProfileId = window.localStorage.getItem("userProfileId");
        userProfileId && dispatch(removeProperty(userProfileId, roll, ownerType));
    }

    return (  
        <div className="remove-property-container">
            <p>{t("remove-property-modal.body") as string}</p>
            <AmpButton onClick={confirmRemoveProperty} type="submit" text={t("remove-property-modal.confirm") as string} disabled={removePropertyState.loading as boolean} />
            <AmpButton onClick={() => dispatch(changeModalState("modal-fade-out"))} type="cancel" text={t("remove-property-modal.cancel") as string} disabled={removePropertyState.loading as boolean} />
        </div>
    )
}
